import { forwardRef } from "react";

/**
 * Anti-spam honeypot for lead forms. Off-screen rather than display:none —
 * bots skip hidden fields — and removed from the tab order and the
 * accessibility tree, so keyboard and screen-reader users never meet it. An
 * unusual name keeps browser autofill off it. The server silently drops any
 * submission where it is filled in (sent as `website`).
 */
export const LeadHoneypot = forwardRef<HTMLInputElement, { id: string }>(({ id }, ref) => (
  <div aria-hidden="true" className="absolute -left-[10000px] h-px w-px overflow-hidden">
    <label htmlFor={id}>Leave this field empty</label>
    <input
      id={id}
      name={id.replace(/-/g, "_")}
      type="text"
      ref={ref}
      tabIndex={-1}
      autoComplete="off"
      defaultValue=""
    />
  </div>
));
LeadHoneypot.displayName = "LeadHoneypot";

export default LeadHoneypot;
